import { useRef } from "react";
function useConstant(fn) {
  const ref = useRef(void 0);
  if (!ref.current) {
    ref.current = { v: fn() };
  }
  return ref.current.v;
}
export {
  useConstant
};
//# sourceMappingURL=useConstant.js.map
